
export const environment = {
  name: 'master',
  production: true,
  appVersion: '38.0.0-prod',
  analyticsKey: 'UA-172071475-2',
  API_HOST: "aws.prdgw.api.united.com",
  WEBEX_URL: "https://custservice.united.upstreamworkssoftware.com",
  EBSO_URL: 'https://ebso.ual.com/pbs/search/main',
  AOD_URL: "https://travelhelp.united.com",
  apiUrl: "https://travelhelp.united.com/api/",
  logging: {
    level: 0,
    enableSourceMaps: true,
  },
  DEPARTMENTS: {
    GENERAL_IAM: { ID: 306482, NAME: "GENERAL_IAM" },
    XYZ: { ID: 6964, NAME: 'XYZ' },
    BAGGAGE: { ID: 306463, NAME: 'BAGGAGE' },
    BAGGAGE_BRC: { ID: 306471, NAME: 'BAGGAGE_BRC' },
    HAWAII_DOC_CHECK: { ID: 306472, NAME: 'HAWAII_DOC_CHECK' },
    DOC_CHECK: { ID: 306474, NAME: 'DOC_CHECK_COMBINED' },
    DOC_CHECK_IAM: { ID: 306490, NAME: 'DOC_CHECK_COMBINED_IAM' },
    PREMIER: { ID: 306470, NAME: 'PREMIER' },
    SPANISH: { ID: 306464, NAME: 'SPANISH' },
    GERMAN: { ID: 306466, NAME: 'GERMAN' },
    FRENCH: { ID: 306465, NAME: 'FRENCH' },
    ITALIAN: { ID: 306478, NAME: 'ITALIAN' },
    PORTUGUESE: { ID: 306476, NAME: 'PORTUGUESE' },
    JAPANESE: { ID: 306475, NAME: 'JAPANESE' },
    HEBREW: { ID: 306477, NAME: 'HEBREW' },
    CHINESE_SMPL: { ID: 306467, NAME: 'CHINESE_SMPL' },
    TRAIN: { ID: 6566, NAME: 'TRAIN' },
    TEST: { ID: 6712, NAME: 'TEST' },
    IAH: { ID: 6556, NAME: 'IAH' },
    ORD: { ID: 6557, NAME: 'ORD' },
    VIP: { ID: 6560, NAME: 'VIP' },
    DEN: { ID: 6576, NAME: 'DEN' },
    SFO: { ID: 6580, NAME: 'SFO' },
    LAX: { ID: 6581, NAME: 'LAX' },
    IAD: { ID: 6582, NAME: 'IAD' },
    EWR: { ID: 6583, NAME: 'EWR' },
    ITALIAN_IAM: { ID: 306489, NAME: 'ITALIAN_IAM' },
    HEBREW_IAM: { ID: 306488, NAME: 'HEBREW_IAM' },
    PORTUGUESE_IAM: { ID: 306487, NAME: 'PORTUGUESE_IAM' },
    JAPANESE_IAM: { ID: 306486, NAME: 'JAPANESE_IAM' },
    CHINESE_SMPL_IAM: { ID: 306485, NAME: 'CHINESE_SMPL_IAM' },
    GERMAN_IAM: { ID: 306484, NAME: 'GERMAN_IAM' },
    FRENCH_IAM: { ID: 306483, NAME: 'FRENCH_IAM' },
    BAGGAGE_IAM: { ID: 306481, NAME: 'BAGGAGE_IAM' },
    PREMIER_IAM: { ID: 306480, NAME: 'PREMIER_IAM' },
    SPANISH_IAM: { ID: 306479, NAME: 'SPANISH_IAM' }
  },
  AOD_CLIENT_SECRET: "",
  EBSO_CLIENT_SECRET: "",
  MAINTENANCE_MODE: false,
  ENABLE_REBOOKING: false,
  CHAT_PROVIDER: 'webex',
  EXTERNAL_API: {
    GET_SKILL_STATUS: '',
    CHECK_SKILL_STATUS: '',
    CALL_CENTER: '',
    BANDWIDTH_CHECK:'',
    BANDWIDTH_AUTH:''
  },
  UW_CONFIG: {
    HEALTH_CHECK_API: {
      TIMEOUT: 10000,
      RETRY: {
        "COUNT": 5,
        "DELAY": 3000
      }
    },
    BANDWIDTH_CHECK_API:{
      VIDEO: 100,
      AUDIO: 300,
      CHAT: 3000
    }
  }
};
